import { GET_USER_LOG_LIST } from 'fixtures/actions'
import { GET_USERS_LOG } from 'fixtures/api'
import { getAllList } from 'services/cmsService'

const getAllUsersLogData = (query = '') => {
  return async dispatch => {
    let data = []
    const limit = 'limit=200'
    const dir = 'sortDir=desc'
    const additional = `${limit}&${dir}`
    const queries = query ? `${query}&${additional}` : `?${additional}`
    let newData = await getAllList(GET_USERS_LOG(queries))
    if (newData) {
      data = newData
    }

    dispatch({
      type: GET_USER_LOG_LIST,
      payload: data
    })
  }
}

export { getAllUsersLogData }
